import type { DictsysEnglishAdjectiveInflectionScheme, DictsysInflectionSchemeTable } from "@/types";

import { getBodyCell } from "./dictsys-inflection-scheme.helper";

export function getTable(
  inflectionScheme: DictsysEnglishAdjectiveInflectionScheme
): DictsysInflectionSchemeTable | null {
  if (!inflectionScheme.adjective) {
    return null;
  }

  return {
    cells: [
      [
        { type: "sub-header", elements: [{ texts: ["Positiv"], comment: "(1. grad)" }] },
        { type: "sub-header", elements: [{ texts: ["Komparativ"], comment: "(2. grad)" }] },
        { type: "sub-header", elements: [{ texts: ["Superlativ"], comment: "(3. grad)" }] }
      ],
      [
        getBodyCell(inflectionScheme.adjective.positive),
        getBodyCell(inflectionScheme.adjective.comparative),
        getBodyCell(inflectionScheme.adjective.superlative)
      ]
    ]
  };
}
